import React, { useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css'; // import the CSS
import { Icon } from '../Icon';
import { OverLay } from '../Others';
import { format } from 'date-fns';

const DateRangePicker = (props) => {
    const [dateRange, setDateRange] = useState(null);

    useEffect(() => {
        if (props.value) {
            setDateRange(props.value)
        } else {
            setDateRange(null);
        }
    }, [props.value]);

    const [toggle, setToggle] = useState(false);

    const handleChange = (range) => {
        setDateRange(range);

        props.handleChange(range);

        if (Array.isArray(range) && range.length === 2) {
            setToggle(false);
        }
    };

    return (
        <div className={"e-range-picker"}>
            {props.label &&
                <label className={`${props.labelStyle} d-flex e-text-chinese-black e-font-14 e-primary-font e-font-weight-400 line-height-18px padding-4px-bottom`}>
                    {props.label}
                    {props.required &&
                        <span className='e-text-carmine-pink'>*</span>
                    }
                </label>
            }

            <div className='position-relative '>
                <div className={`${toggle ? 'e-border-0-5px-blue-violet' : 'e-border-1px-light-purple'} e-bg-white padding-10px-tb padding-10px-lr d-flex justify-content-between border-radius-8 cursor-pointer`}
                    onClick={() => setToggle(prev => !prev)} style={{ width: props.width ? props.width : "180px" }}>
                    {dateRange !== null ?
                        <>
                            <p className='mb-0 e-primary-font e-font-14 e-text-chinese-black e-font-weight-500 line-height-18px d-flex'>
                                {format(dateRange[0], 'dd/MM/yyyy')} - {format(dateRange[1], 'dd/MM/yyyy')}
                            </p>
                            <div onClick={(event) => event.stopPropagation()}>
                                <Icon icon="close"
                                    className='cursor-pointer d-flex position-relative '
                                    size="16px"
                                    onClick={() => {
                                        setDateRange(null);
                                        props.handleClear();
                                    }} />
                            </div>
                        </>
                        :
                        <>
                            <p className='mb-0 e-text-davys-grey-light e-primary-font e-font-14 e-font-weight-500 line-height-18px'>
                                {props.placeholder}
                            </p>
                            <img src={require("../../Assets/Image/Others/calendar.svg").default} />
                        </>
                    }
                </div>
                {toggle &&
                    <>
                        <OverLay isOpen={toggle} onClose={() => setToggle(false)} />
                        <div className={`${props.calendarWrapperClass} position-absolute z-3`}>
                            <Calendar
                                selectRange={true}
                                value={dateRange}
                                maxDate={props.maxDate}
                                minDate={props.minDate}
                                onChange={handleChange}
                            />
                        </div>
                    </>
                }
            </div>
        </div>
    );
};

export default DateRangePicker;
